import SharedMap from './SharedMap';

export default SharedMap;
